import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type P = {
  referrer?: string;
};

export const useOnSuccessLogin = <T extends { referrer?: string }>({ referrer }: P = {}) => {
  const history = useHistory();
  const { state } = useLocation<T | undefined>();

  return useMemo(
    () => ({
      onSuccessLogin() {
        let finalReferrer = state?.referrer ?? referrer ?? '/';
        if (['/login', '/sign-up', '/new-password', '/forgot-password'].includes(finalReferrer)) {
          finalReferrer = '/';
        }

        history.push(finalReferrer);
      },
    }),
    [history, state, referrer],
  );
};
